import styled, { keyframes } from 'styled-components';

const float = keyframes`
  0% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-15px) rotate(1deg); }
  100% { transform: translateY(0px) rotate(0deg); }
`;

export const HeroContainer = styled.div`
  background: #000000;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  padding: 120px 40px;

  &::before {
    content: '';
    position: absolute;
    width: 200%;
    height: 100%;
    bottom: -50%;
    left: 50%;
    transform: translateX(-50%) perspective(1000px) rotateX(60deg);
    background-image: 
      linear-gradient(rgba(133, 76, 230, 0.08) 1.5px, transparent 1.5px),
      linear-gradient(90deg, rgba(133, 76, 230, 0.08) 1.5px, transparent 1.5px);
    background-size: 100px 100px;
    mask-image: linear-gradient(to top, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 80%);
    opacity: 0.4;
  }
`;

export const InnerWrapper = styled.div`
  width: 100%;
  max-width: 1300px;
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  align-items: center;
  gap: 80px;
  z-index: 2;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    text-align: center;
    gap: 60px;
  }
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
`;

export const Label = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #854CE6;
  text-transform: uppercase;
  letter-spacing: 0.4em;
`;

export const MainTitle = styled.h2`
  font-size: 72px;
  font-weight: 800;
  color: #FFFFFF;
  line-height: 1.1;
  letter-spacing: -0.04em;

  span {
    color: transparent;
    -webkit-text-stroke: 1px rgba(255, 255, 255, 0.3);
  }

  @media (max-width: 768px) {
    font-size: 48px;
  }
`;

export const Description = styled.p`
  font-size: 20px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.6;
  max-width: 550px;
  
  @media (max-width: 1024px) {
    margin: 0 auto;
  }
`;

export const VisualMural = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  position: relative;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const PillarCard = styled.div`
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.06);
  padding: 36px;
  border-radius: 24px;
  backdrop-filter: blur(12px);
  animation: ${float} 8s ease-in-out infinite;
  animation-delay: ${({ delay }) => delay || '0s'};
  transition: all 0.4s ease;

  &:hover {
    background: rgba(133, 76, 230, 0.05);
    border-color: rgba(133, 76, 230, 0.3);
    transform: translateY(-8px) scale(1.02);
  }
  
  &:nth-child(even) {
    transform: translateY(60px);

    @media (max-width: 640px) {
        transform: translateY(0);
    }
  }
`;

export const PillarIcon = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(133, 76, 230, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #854CE6;
  margin-bottom: 24px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
`;

export const PillarTitle = styled.h4`
  font-size: 20px;
  font-weight: 700;
  color: #FFFFFF;
  margin-bottom: 12px;
`;

export const PillarText = styled.p`
  font-size: 15px;
  color: rgba(255, 255, 255, 0.4);
  line-height: 1.6;
`;

export const CTAWrapper = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 24px;

  @media (max-width: 1024px) {
    justify-content: center;
  }
`;

export const PrimaryButton = styled.a`
  padding: 16px 32px;
  background: #FFFFFF;
  color: #000;
  text-decoration: none;
  font-weight: 700;
  border-radius: 50px;
  font-size: 15px;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);

  &:hover {
    background: #854CE6;
    color: #FFF;
    transform: translateY(-4px);
    box-shadow: 0 10px 20px rgba(133, 76, 230, 0.2);
  }
`;

export const SecondaryButton = styled.a`
  padding: 16px 32px;
  background: transparent;
  color: #FFFFFF;
  border: 1px solid rgba(255, 255, 255, 0.15);
  text-decoration: none;
  font-weight: 700;
  border-radius: 50px;
  font-size: 15px;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
    border-color: #FFFFFF;
  }
`;
